import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { attendeeApi, attendeeAuth } from '@/api/attendee'
import { Button } from '@/components/ui/button'
import { Mail, CheckCircle2 } from 'lucide-react'

export default function AttendeeRequestLinkPage() {
  const { slug } = useParams<{ slug: string }>()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  const mutation = useMutation({
    mutationFn: () => attendeeApi.requestLink(slug!, email),
    onSuccess: () => {
      if (slug) attendeeAuth.rememberSlug(slug)
      setSent(true)
    },
  })

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
        {sent ? (
          <div className="text-center">
            <CheckCircle2 size={40} className="mx-auto text-green-500 mb-3" />
            <h1 className="text-lg font-semibold text-slate-900 mb-1">Check your inbox</h1>
            <p className="text-sm text-slate-500">
              If <strong>{email}</strong> matches a booking, we've sent a sign-in link. It expires in 15 minutes.
            </p>
          </div>
        ) : (
          <>
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full bg-indigo-50 flex items-center justify-center">
                <Mail size={22} className="text-indigo-500" />
              </div>
            </div>
            <h1 className="text-lg font-semibold text-slate-900 text-center mb-1">Attendee sign-in</h1>
            <p className="text-sm text-slate-500 text-center mb-6">
              Enter your email and we'll send you a secure link to view your bookings and certificates — no password needed.
            </p>
            <form
              onSubmit={e => { e.preventDefault(); mutation.mutate() }}
              className="space-y-4"
            >
              <input
                required
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
              <Button type="submit" className="w-full" disabled={mutation.isPending}>
                {mutation.isPending ? 'Sending…' : 'Send sign-in link'}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
